import { Badge, IconButton, Menu, MenuItem } from '@material-ui/core';
import { AttachMoney, Chat, CloudUpload } from '@material-ui/icons';
import { useLoanRoutes } from '@roc/feature-loans-routes-config';
import { TamariskPayment, AppraisalPaymentLinkModal } from '@roc/feature-documents';

import GetAppIcon from '@material-ui/icons/GetApp';

import {
  ActionsColumn,
  DataGrid as Grid, FileUpload, GridColumnProps, StandardDialog,

  LinkColumn,
  SelectFilterComponent,
  SelectFloatingFilterComponent, TextColumn
} from '@roc/ui';
import { observer } from 'mobx-react';
import React, { useState } from 'react';
import { AppraisalFileUploadModal } from './appraisalFileUploadModal';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { formatDate, insertIf } from '@roc/feature-utils';
import { APPRAISAL_PAYMENT_STANDALONE } from '@roc/feature-loan-fasttrack';
import {
  AppraisalDashboardStatus,
  STATIC_DOCUMENT_TYPES,
} from '../../utils/utils';
import { useStore } from '@roc/client-portal-shared/hooks';
import { formatCurrency } from 'libs/feature-documents/src/documents/stores/documentForms/appraisalDetailsV2/appraisalDetailsV2Store';
const APPRAISAL_PAYMENT_LOAN = 'Appraisal_Loan';

const usdAmount: any = params => {
  return params.value && formatCurrency(Number(params.value));
};


const columns: GridColumnProps[] = [
  {
    field: 'loanId',
    headerName: 'Loan Id',
    maxWidth: 100,
    cellRenderer: 'loanIdCellRenderer',
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
    pinned: 'left',
    lockPinned: true,
  },
  {
    field: 'orderId',
    headerName: 'Order Id',
    maxWidth: 200,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
    pinned: 'left',
    lockPinned: true,
  },
  {
    field: 'subType',
    headerName: 'Appraisal Type',
    maxWidth: 200,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
    pinned: 'left',
    lockPinned: true,
  },
  {
    field: 'subjectProperty',
    headerName: 'Subject Property',
    cellRenderer: 'addressCellRenderer',
    minWidth: 340,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'appraisalType',
    headerName: 'Appraisal Product',
    minWidth: 165,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'amcName',
    headerName: 'AMC',
    minWidth: 165,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'status',
    headerName: 'Status',
    minWidth: 118,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'amount',
    headerName: 'Amount',
    minWidth: 140,
    valueFormatter: usdAmount,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'paidDate',
    headerName: 'Paid Date',
    minWidth: 140,
    filter: 'agDateColumnFilter',
    cellRenderer: 'dateCellRenderer',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'paidBy',
    headerName: 'Paid By',
    minWidth: 140,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'orderCreationDate',
    headerName: 'Order Creation Date',
    minWidth: 140,
    filter: 'agDateColumnFilter',
    cellRenderer: 'dateCellRenderer',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'inspectionDate',
    headerName: 'Inspection Date',
    minWidth: 140,
    filter: 'agDateColumnFilter',
    cellRenderer: 'dateCellRenderer',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'dueDate',
    headerName: 'Due Date',
    minWidth: 140,
    filter: 'agDateColumnFilter',
    cellRenderer: 'dateCellRenderer',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'completedDate',
    headerName: 'Completed Date',
    minWidth: 140,
    filter: 'agDateColumnFilter',
    cellRenderer: 'dateCellRenderer',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'actions',
    headerName: 'Actions',
    maxWidth: 130,
    cellRenderer: 'actionsCellRenderer',
    pinned: 'right',
    lockPinned: true,
  },
];

const ActionsMenu = observer(({ anchorEl, setAnchorEl, openMenu, params, actionsMenu }) => {
  const handleClose = () => {
    setAnchorEl(null)
  }

  const getActionButton = (Icon, text, onClick) => {
    return (
      <>
        <MenuItem key={`menu_${text}`} onClick={() => onClick(params)}>
          <IconButton>
            <Icon color={'primary'} style={{ marginRight: '10px', fontSize: '17px' }} /> <span style={{ fontSize: '15px' }}> {text} </span>
          </IconButton>
        </MenuItem>
      </>
    )
  }

  return (
    <Menu
      id='menu-actions'
      getContentAnchorEl={null}
      anchorEl={anchorEl}
      keepMounted
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'left'
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left'
      }}
      open={openMenu}
      onClose={handleClose}
    >
      {actionsMenu.map(action => {
        return getActionButton(action.icon, action.text, action.onClickAction)
      })}
    </Menu>
  )
})
export const LoanAppraisalsGrid = observer(({ onOpenCommunication, onSelectAppraisal = null }) => {
  const [currentAppraisal, setCurrentAppraisal] = useState(null);
  const [isFileUploadModalOpen, setIsFileUploadModalOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const openMenu = Boolean(anchorEl);

  const { appraisalsStore, loanStore, appraisalDetailsV2Store } = useStore();
  const { globalStore } = appraisalsStore;
  const { appraisalActionsStore } = appraisalDetailsV2Store;
  const { loanRoutesConfig } = useLoanRoutes();

  const [isTamariskPaymentModalOpen, setIsTamariskModalOpen] = useState(false);
  const [isPaymentLinkOpen, setIsPaymentLinkOpen] = useState(false);

  const frameworkComponents = {
    selectFilter: SelectFilterComponent,
    selectFloatingFilter: SelectFloatingFilterComponent,
    loanIdCellRenderer: params => {
      return globalStore.isInternalPortal ?
        LinkColumn({
          ...params,
          onClick: () => window.parent.postMessage({ loanId: params.node.data?.loanId }, '*'),
        }) :
        LinkColumn({
          ...params,
          url: loanRoutesConfig.loans(params.value).children.dashboard.url,
        });
    },
    addressCellRenderer: params => {
      return LinkColumn({
        ...params,
        url: '#',
        onClick: () => onSelectAppraisal(params.node.data),
      });
    },
    dateCellRenderer(params) {
      return params.value
        ? formatDate(params.value, 'MM/dd/yyyy')
        : '';
    },
    actionsCellRenderer: params =>
      ActionsColumn({
        ...params,
        actions: getActions(params),
      }),
  };

  const onFilterChanged = params => {
    const filterModel = params.api.getFilterModel();
    appraisalsStore.loanAppraisalsGridStore.setFilterModel(filterModel);
  };

  const openActionsMenu = (e: Event, appraisal) => {
    setCurrentAppraisal(appraisal)
    setAnchorEl(e.currentTarget)
  }

  const openPaymentLinkModal = async (appraisal) => {
    if (appraisal?.loanId) {
      await loanStore.fetchLoanDetails(appraisal?.loanId);
      setIsPaymentLinkOpen(true);
      return;
    }
    setCurrentAppraisal(appraisal);
    setIsPaymentLinkOpen(true);
    setAnchorEl(null);
  };

  const getActions = params => [
    {
      icon: (
        <Badge badgeContent={params.node.data?.unreadMessages} color="primary">
          <Chat color="primary" />
        </Badge>
      ),
      onClick: () => onOpenCommunication(params.node.data),
    },
    {
      icon: <MoreVertIcon color="primary" />,
      onClick: e => openActionsMenu(e, params.node.data)
    }
  ];

  const openFileUploadModal = (appraisal) => {
    setCurrentAppraisal(appraisal);
    setIsFileUploadModalOpen(true);
    setAnchorEl(null);
  };

  const downloadAppraisalReport = (appraisal) => {
    appraisalActionsStore.downloadValuationReport(appraisal?.loanId, appraisal?.propertyId,
      appraisal?.clientReferenceId);
    setAnchorEl(null);
  }

  const actionsMenu = [
    ...insertIf(!currentAppraisal?.loanId && currentAppraisal?.status !== AppraisalDashboardStatus.COMPLETED, [{
      icon: CloudUpload,
      onClickAction: openFileUploadModal,
      text: 'Upload Document'
    }]),
    ...insertIf(AppraisalDashboardStatus.COMPLETED === currentAppraisal?.status, [{
      icon: GetAppIcon,
      onClickAction: downloadAppraisalReport,
      text: 'Download Report'
    }]),
    ...insertIf(currentAppraisal?.anyPaymentPending, [{
      icon: AttachMoney,
      onClickAction: () => openPaymentLinkModal(currentAppraisal),
      text: 'Payment Link'
    }])
  ];

  const closeTamariskPaymentModal = () => {
    setIsTamariskModalOpen(false);
    setCurrentAppraisal(null);
  };

  const closeFileUploadModal = () => {
    setIsFileUploadModalOpen(false);
    setCurrentAppraisal(null);
  };

  const onUpload = (documentType: string, fileUpload: FileUpload) => {
    const { loanPropertyValuationId, loanId } = currentAppraisal;
    appraisalsStore.uploadStandaloneValuationDocument(
      loanPropertyValuationId,
      loanId != null,
      documentType,
      fileUpload
    );
  };

  const onSortChanged = params => {
    const sortModel = params.api.getSortModel();
    appraisalsStore.loanAppraisalsGridStore.setSortModel(sortModel);
  };

  return (
    <>
      <Grid
        columns={columns}
        rows={appraisalsStore.loanAppraisalsGridStore.gridData.data.rows}
        frameworkComponents={frameworkComponents}
        onSortChanged={onSortChanged}
        onFilterChanged={onFilterChanged}
        isLoading={appraisalsStore.loanAppraisalsGridStore.isLoading}
        showFilters={appraisalsStore.loanAppraisalsGridStore.showFilters}
        sortModel={appraisalsStore.loanAppraisalsGridStore.sortModel}
        filterModel={appraisalsStore.loanAppraisalsGridStore.filterModel}
        paginationData={appraisalsStore.loanAppraisalsGridStore.gridData.meta}
        setPageNumber={appraisalsStore.loanAppraisalsGridStore.setPageNumber}
      />
      <AppraisalFileUploadModal
        open={isFileUploadModalOpen}
        values={STATIC_DOCUMENT_TYPES}
        onClose={closeFileUploadModal}
        onUpload={onUpload}
      />
      <StandardDialog
        open={isTamariskPaymentModalOpen}
        title="Tamarisk Payment"
        maxWidth="md"
        handleClose={closeTamariskPaymentModal}
        dialogContent={
          <TamariskPayment
            borrowersEmail={currentAppraisal?.borrowersEmail}
            tamariskURL={currentAppraisal?.tamariskUrl}
            entityId={currentAppraisal?.loanId ? currentAppraisal?.loanId : currentAppraisal?.loanPropertyValuationId}
            paymentStatus={currentAppraisal?.paymentStatus}
            type={currentAppraisal?.loanId ? APPRAISAL_PAYMENT_LOAN : APPRAISAL_PAYMENT_STANDALONE}
          />
        }
      />
      <AppraisalPaymentLinkModal
        open={isPaymentLinkOpen}
        onClose={() => setIsPaymentLinkOpen(false)}
        store={appraisalDetailsV2Store}
        loanId={currentAppraisal?.loanId}
        lenderId={currentAppraisal?.lenderId}
        clientReferenceId={currentAppraisal?.clientReferenceId}
      />
      <ActionsMenu
        openMenu={openMenu}
        anchorEl={anchorEl}
        setAnchorEl={setAnchorEl}
        params={currentAppraisal}
        actionsMenu={actionsMenu}
      />
    </>
  );
});
